import type { Lens } from '@hookform/lenses';
import { z } from 'zod/v4';
import NumberIcon from '@interxfi/design-system/icons/react/icon-number';
import type { IxcFundingV1AccountNumbersControls } from '@interxfi/types/generated/api';
import { AccordionFormGroup } from '../../../../../../components/card-group/form/accordion-form-group';
import { AppSwitchInputWithLens } from '../../../../../../components/form/app-switch-input';

export const programControlsAccountNumbersFormSchema = z.object({
  canCreate: z.boolean(),
});

export type ProgramControlsAccountNumbersFormValues = z.infer<typeof programControlsAccountNumbersFormSchema>;

export const programControlsAccountNumbersFormDefaultValues: ProgramControlsAccountNumbersFormValues = {
  canCreate: false,
};

export function getInitialFormValuesForProgramAccountNumbersControls(
  data: IxcFundingV1AccountNumbersControls | undefined,
): ProgramControlsAccountNumbersFormValues {
  if (!data) {
    return programControlsAccountNumbersFormDefaultValues;
  }

  return {
    canCreate: Boolean(data.settings?.canCreate),
  };
}

export function formValuesToProgramAccountNumbersControls(values: ProgramControlsAccountNumbersFormValues): IxcFundingV1AccountNumbersControls {
  return {
    settings: {
      canCreate: values.canCreate,
    },
  };
}

interface ProgramAccountNumbersControlsFormProps {
  lens: Lens<ProgramControlsAccountNumbersFormValues>;
}

export function ProgramAccountNumbersControlsForm({ lens }: ProgramAccountNumbersControlsFormProps) {
  return (
    <AccordionFormGroup icon={<NumberIcon aria-hidden />} title="Account Numbers">
      <AccordionFormGroup.Section
        toggleInputElement={<AppSwitchInputWithLens align="space-between" label="Can Create" lens={lens.focus('canCreate')} />}
      />
    </AccordionFormGroup>
  );
}
